<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="row mx-auto my-2 py-4">
        <div class="col-md-4 p-0 mx-auto">
          <component
            is="qrMaker"
            :loading="loading"
            :svg="data.svg"
          ></component>
        </div>
        <div class="col-md mx-auto p-3">
          <v-stepper v-model="e6" class="px-0 mx-0" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>ورود اطلاعات</p>
                  <div v-if="e6 === 1">
                    <v-switch v-model="qrType" disabled>
                      <template v-slot:label>
                        <span class="text-muted"> کیوآر داینامیک باشد</span>
                        <p class="text-danger ml-2">به زودی</p>
                      </template>
                    </v-switch>
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کیوآر"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام کیوآر"
                      style="padding-top: 40px !important"
                    />
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <qr-address-field
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      append-icon="mdi-web"
                      class="mt-0 pt-0 contentinfo"
                      dense
                      hint="!برای استفاده از آدرس پیشفرض، خالی بگذارید"
                      outlined
                      persistent-hint
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="آدرس"
                      style="padding-top: 40px !important"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion icon="map-marker" single title="لوکیشن">
                <template v-slot:content>
                  <div class="rowinfo">
                    <v-textarea
                      v-model="address"
                      append-icon="mdi-map"
                      dense
                      disabled
                      class="rowinfo"
                      label="آدرس"
                      outlined
                      rows="3"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-address`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="آدرس"
                      style="padding-top: 40px !important"
                    />
                  </div>
                  <template>
                    <div class="col-md-12">
                      <mapir
                        :apiKey="apiKey"
                        :center="center"
                        :zoom="15"
                        class="col-md-12"
                        style="width: 100%; height: 500px"
                        @click="getlatLng"
                      >
                        <mapNavigationControl position="top-right" />
                        <mapMarker
                          :coordinates.sync="coordinates"
                          color="red"
                          draggable
                          kind="marker"
                          type="marker"
                        >
                          <template v-slot:marker>
                            <v-icon color="red">location_on</v-icon>
                          </template>
                        </mapMarker>
                      </mapir>
                    </div>
                  </template>
                </template>
              </list-expansion>

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="preview"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step
              v-if="qrType"
              :complete="e6 > 2"
              class="px-0 px-md-4"
              step="2"
              >تنظیمات کیوآر</v-stepper-step
            >

            <v-stepper-content
              v-if="qrType"
              class="pr-1 mx-0 mr-md-7 px-md-4"
              step="2"
            >
              <qr-management :data="data" />
            </v-stepper-content>

            <v-stepper-step
              :complete="qrType ? e6 > 3 : e6 > 2"
              :step="qrType ? 3 : 2"
              class="px-0 px-md-4"
            >
              دیزاین کیوآر
            </v-stepper-step>

            <v-stepper-content
              :step="qrType ? 3 : 2"
              class="pr-1 mx-0 mr-md-7 px-md-4"
            >
              <qr-customize v-model="qrDesign" />
              <div class="row mx-auto">
                <div class="col-md-12 d-flex w-100 justify-space-between">
                  <div class="rowinfo" style="width: 100%">
                    <v-btn
                      v-if="data.svg"
                      class="btn-download ma-0"
                      @click="showDialog = true"
                    >
                      <v-icon>mdi-progress-download</v-icon>
                      {{ $t("download_qr") }}                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-data-svg`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="دانلود کیوآر"
                      style="padding-top: 40px !important"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>
        </div>
        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-download-Qr`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="px-5">
            <download-file v-if="showDialog" :svg="data.svg" />
          </v-card>
        </custom-popup>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrGenerator from "./qrGenerator";
import qrMaker from "./qrMaker";
import { debounce } from "@/main";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import axios from "axios";
import DownloadFile from "../downloadFile";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import NextBtn from "@/view/content/fragments/nextBtn";

export default {
  name: "qrLocation",
  components: {
    NextBtn,
    QrCustomize,
    QrManagement,
    ListExpansion,
    QrAddressField,
    DownloadFile,
    QrGenerator,
    qrMaker,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
  },
  data() {
    return {
      serviceName: "Qrland",
      componentName: "qrLocation",
      helpData: [],

      dtUrl: null,
      e6: 1,
      cons: { title: "دانلود کیوآر" },
      showDialog: false,
      apiKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      center: [51.420296, 35.732379],
      coordinates: [51.420296, 35.732379],
      address: "",
      data: {
        link: "",
        shortLink: "",
        svg: "",
      },
      loading: false,
      qrType: false,
      visitName: "لوکیشن",
      qrDesign: {},
    };
  },
  methods: {
    markQr() {
      this.loading = true;
      this.$api
        .post("/v1/Qr", {
          type: "Geo",
          format: "svg",
          size: 248,
          qrType: this.qrType ? "dynamic" : "static",
          latitude: this.coordinates[1],
          longitude: this.coordinates[0],
          visitName: this.visitName,
          margin: 0,
          shorten: true,
          qr: {
            section: "#location",
            lat: this.coordinates[1],
            lng: this.coordinates[0],
            backcolor: "#ffffff",
            frontcolor: "#000000",
            gradient_color: "#8900d5",
            marker_out_color: "#000000",
            marker_in_color: "#000000",
            marker_top_right_outline: "#000000",
            marker_top_right_center: "#000000",
            marker_bottom_left_outline: "#000000",
            marker_bottom_left_center: "#000000",
            framecolor: "#000000",
            optionlogo: "none",
            "logo-size": 100,
            marker: "default",
            marker_in: "default",
            outer_frame: "none",
            framelabel: "SCAN ME",
            label_font: "AbrilFatface.svg",
            "label-text-size": 100,
            size: "248",
            level: "M",
          },
        })
        .then((res) => {
          this.loading = false;
          this.data.svg = this.qrType ? res.data.data.svg : res.data.data.svg;
          if (this.e6 === 1) {
            this.e6 = 2;
          }
          this.$toast.success("کد کیوآر شما با موفقیت ساخته شد.");
          this.data.shortLink = res.data.data.url;
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error("خطای سرور!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getlatLng(e) {
      this.coordinates = Object.values(e.actualEvent.lngLat);
      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: { lat: this.coordinates[1], lon: this.coordinates[0] },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }).then((response) => {
        this.address = response.data.address;
      });
    },
    preview() {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", {
          section: "#location",
          lat: this.coordinates[1],
          lng: this.coordinates[0],
          backcolor: !this.qrDesign.qrStyleColors?.backcolor
            ? "#ffffff"
            : this.qrDesign.qrStyleColors?.backcolor,
          gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
            ? "#8900d5"
            : this.qrDesign.qrStyleColors?.gradient_color,
          frontcolor: !this.qrDesign.qrStyleColors?.frontColor
            ? "#000000"
            : this.qrDesign.qrStyleColors?.frontColor,
          gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : undefined,
          pattern: this.qrDesign.qrStyleColors.pattern,
          marker_in: this.qrDesign.MarkerCenter.eyePattern,
          marker_in_color: this.qrDesign.MarkerCenter.main,
          markers_color: "on",
          marker: this.qrDesign.QrMarkOut.markOutPattern,
          different_markers_color:
            this.qrDesign.QrMarkOut.different_markers_color ||
            this.qrDesign.MarkerCenter.different_markers_color
              ? "on"
              : undefined,
          marker_out_color: this.qrDesign.QrMarkOut.main,
          marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
          marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
          marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
          marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
          custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
            ? "on"
            : undefined,
          outer_frame: this.qrDesign.QrFrame.framePattern,
          framecolor: this.qrDesign.QrFrame.main,
          framelabel: this.qrDesign.QrFrame.text,
          optionlogo: this.qrDesign.LogoImg.logoImg,
          no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : undefined,
          "logo-size": this.qrDesign.LogoImg.logoSize,
          label_font: "AbrilFatface.svg",
          "label-text-size": "100",
          size: "248",
          level: "H",
        })
        .then((res) => {
          this.loading = false;
          this.data.svg = res.data.data;
          if (this.e6 === 1) {
            this.e6 = 2;
          }
          this.$toast.success("کد کیوآر شما با موفقیت ساخته شد.");
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error("خطای سرور!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    qrDesign: {
      handler() {
        if (this.data.svg) {
          debounce(() => {
            this.preview();
          }, 2000);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
